/* =====================================================
   BUNA UTOPIA — Shopify Theme JS
   ===================================================== */

// ── EMAILJS INIT ──
emailjs.init('y13yaQvk45E4qNxC0');

// ── QUANTITY SELECTOR ──
function changeQty(delta) {
  const qtyEl = document.getElementById('drawerQty');
  if (!qtyEl) return;
  let current = parseInt(qtyEl.textContent) || 1;
  current = Math.max(1, current + delta);
  qtyEl.textContent = current;
}

// ── PRODUCT PAGE ADD TO CART ──
function pdpAddToCart(variantId) {
  if (!variantId) { showToast('Please select an option.'); return; }
  showToast('Adding to cart… ✦');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  })
  .then(function(r) { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
  .then(function() { setTimeout(function() { window.location.href = '/cart'; }, 800); })
  .catch(function() { showToast('Something went wrong. Please try again.'); });
}

// ── MOBILE NAV TOGGLE (works on all pages) ──
function toggleMenu() {
  var menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.toggle('open');
}

// ── PRODUCT DRAWER — driven by data-attributes on cards ──

function openDrawerFromCard(cardEl) {
  const name      = cardEl.dataset.name;
  const region    = cardEl.dataset.region;
  const process   = cardEl.dataset.process;
  const price     = cardEl.dataset.price;
  const img       = cardEl.dataset.img;
  const desc      = cardEl.dataset.desc;
  const soldOut   = cardEl.dataset.soldOut === 'true';
  const handle    = cardEl.dataset.handle;
  const hasOptions = cardEl.dataset.hasOptions === 'true';
  const variantId = cardEl.dataset.variantId;

  let variants = [];
  let options  = [];
  try { variants = JSON.parse(cardEl.dataset.variants || '[]'); } catch(e) {}
  try { options  = JSON.parse(cardEl.dataset.options  || '[]'); } catch(e) {}

  document.getElementById('drawerImg').src = img;
  document.getElementById('drawerImg').alt = name;
  document.getElementById('drawerRegion').textContent  = region;
  document.getElementById('drawerName').textContent    = name;
  document.getElementById('drawerProcess').textContent = process;
  document.getElementById('drawerDesc').textContent    = desc;
  document.getElementById('drawerPrice').textContent   = price;

  const qtyEl = document.getElementById('drawerQty');
  if (qtyEl) qtyEl.textContent = '1';

  const noteTags = cardEl.querySelectorAll('.note-tag');
  document.getElementById('drawerNotes').innerHTML =
    Array.from(noteTags).map(n => `<span class="note-tag">${n.textContent}</span>`).join('');

  const regionLower = region.toLowerCase();
  let meta = [];
  if (regionLower.includes('yirgacheffe')) {
    meta = [
      { label: 'Altitude',  val: '1,900 – 2,400m' },
      { label: 'Cup Score', val: '86+' },
      { label: 'Harvest',   val: 'Nov – Feb' },
      { label: 'Variety',   val: 'JARC 74110 / Heirloom' },
      { label: 'Farm',      val: 'Smallholder farms · Yirgacheffe' }
    ];
  } else if (regionLower.includes('sidamo')) {
    meta = [
      { label: 'Altitude',  val: '1,800 – 2,200m' },
      { label: 'Cup Score', val: '84+' },
      { label: 'Harvest',   val: 'Oct – Jan' },
      { label: 'Variety',   val: 'Heirloom Ethiopian' },
      { label: 'Farm',      val: 'Smallholder farms · Sidamo' }
    ];
  } else if (regionLower.includes('guji')) {
    meta = [
      { label: 'Altitude',  val: '1,800 – 2,200m' },
      { label: 'Cup Score', val: '87+' },
      { label: 'Harvest',   val: 'Nov – Jan' },
      { label: 'Variety',   val: 'Heirloom Ethiopian' },
      { label: 'Farm',      val: 'Smallholder farms · Guji Zone' }
    ];
  } else if (regionLower.includes('harrar')) {
    meta = [
      { label: 'Altitude',  val: '1,500 – 2,100m' },
      { label: 'Cup Score', val: '84+' },
      { label: 'Harvest',   val: 'Oct – Dec' },
      { label: 'Variety',   val: 'Heirloom Ethiopian' },
      { label: 'Farm',      val: 'Smallholder farms · Harrar' }
    ];
  } else {
    meta = [
      { label: 'Origin',    val: 'Ethiopia' },
      { label: 'Grade',     val: 'Grade 1 Premium' },
      { label: 'Variety',   val: 'Heirloom Ethiopian' }
    ];
  }
  document.getElementById('drawerMeta').innerHTML = meta.map(m =>
    `<div class="drawer-meta-item"><span class="drawer-meta-label">${m.label}</span><span class="drawer-meta-val">${m.val}</span></div>`
  ).join('');

  const selectorsDiv = document.getElementById('drawerVariantSelectors');
  selectorsDiv.innerHTML = '';

  let selectedVariantId = variantId;

  if (hasOptions && variants.length > 1 && options.length > 0) {
    selectorsDiv.style.cssText = 'margin-bottom:1.2rem;display:flex;flex-direction:column;gap:0.8rem;';

    options.forEach(opt => {
      const label = document.createElement('label');
      label.style.cssText = 'font-family:"DM Sans",sans-serif;font-size:0.8rem;letter-spacing:0.08em;text-transform:uppercase;color:rgba(242,245,238,0.6);display:block;margin-bottom:0.3rem;';
      label.textContent = opt.name;

      const select = document.createElement('select');
      select.dataset.optionName = opt.name;
      select.style.cssText = 'width:100%;padding:0.6rem 1rem;background:rgba(13,31,15,0.8);border:1px solid rgba(201,168,76,0.3);color:var(--cream);font-family:"DM Sans",sans-serif;font-size:0.9rem;border-radius:0;cursor:pointer;';

      opt.values.forEach(val => {
        const option = document.createElement('option');
        option.value = val;
        option.textContent = val;
        select.appendChild(option);
      });

      select.addEventListener('change', () => {
        const allSelects = selectorsDiv.querySelectorAll('select');
        const selectedValues = Array.from(allSelects).map(s => s.value);
        const matched = variants.find(v => {
          const titles = v.title.split(' / ');
          return selectedValues.every(sv => titles.includes(sv));
        });
        if (matched) {
          selectedVariantId = String(matched.id);
          document.getElementById('drawer').dataset.variantId = selectedVariantId;
          const matchedPrice = matched.price;
          if (matchedPrice) {
            const priceNum = parseFloat(matchedPrice);
            const displayPrice = priceNum > 500 ? (priceNum / 100).toFixed(2) : priceNum.toFixed(2);
            document.getElementById('drawerPrice').textContent = '$' + displayPrice + ' USD';
          }
        }
      });

      const wrapper = document.createElement('div');
      wrapper.appendChild(label);
      wrapper.appendChild(select);
      selectorsDiv.appendChild(wrapper);
    });

    selectedVariantId = String(variants[0].id);
  }

  const drawer = document.getElementById('drawer');
  drawer.dataset.variantId = selectedVariantId;
  drawer.dataset.soldOut   = soldOut ? 'true' : 'false';
  drawer.dataset.handle    = handle;

  const detailsLink = document.getElementById('drawerFullDetails');
  if (detailsLink && handle) detailsLink.href = `/products/${handle}`;

  const btn = document.getElementById('drawerBtn');
  if (btn) {
    if (soldOut) {
      btn.textContent = 'Sold Out';
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
    } else {
      btn.textContent = 'Add to Cart — Shop Now';
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
    }
  }

  document.getElementById('drawerOverlay').classList.add('open');
  drawer.classList.add('open');
  document.body.style.overflow = 'hidden';

  if (handle) history.pushState({ handle }, name, `/products/${handle}`);
}

function openDrawer(id) {
  const card = document.querySelector(`[data-handle="${id}"]`) ||
               document.querySelector(`[data-product-id="${id}"]`);
  if (card) openDrawerFromCard(card);
}

function closeDrawer() {
  const sel = document.getElementById('drawerVariantSelectors');
  if (sel) sel.innerHTML = '';
  document.getElementById('drawerOverlay').classList.remove('open');
  document.getElementById('drawer').classList.remove('open');
  document.body.style.overflow = '';
  if (history.state && history.state.handle) history.back();
}

window.addEventListener('popstate', (e) => {
  if (e.state && e.state.handle) {
    const card = document.querySelector(`[data-handle="${e.state.handle}"]`);
    if (card) openDrawerFromCard(card);
  } else {
    const overlay = document.getElementById('drawerOverlay');
    const drawer  = document.getElementById('drawer');
    if (overlay) overlay.classList.remove('open');
    if (drawer)  drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
});

(function autoOpenDrawerFromUrl() {
  const path = window.location.pathname;
  const isHomepage = path === '/' || path === '';
  const isCollections = path.startsWith('/collections');
  if (!isHomepage && !isCollections) return;
  const params = new URLSearchParams(window.location.search);
  const queryHandle = params.get('product');
  if (queryHandle) {
    window.addEventListener('DOMContentLoaded', () => {
      const card = document.querySelector(`[data-handle="${queryHandle}"]`);
      if (card) openDrawerFromCard(card);
    });
    return;
  }
  const hash = window.location.hash.replace('#', '');
  if (hash) {
    window.addEventListener('DOMContentLoaded', () => {
      const card = document.querySelector(`[data-handle="${hash}"]`);
      if (card) openDrawerFromCard(card);
    });
  }
})();

// ── ADD TO CART (drawer) ──
function addToCart() {
  const drawer  = document.getElementById('drawer');
  const soldOut = drawer.dataset.soldOut === 'true';
  const variantId = drawer.dataset.variantId;
  const qtyEl = document.getElementById('drawerQty');
  const quantity = qtyEl ? (parseInt(qtyEl.textContent) || 1) : 1;
  if (soldOut) { showToast('This product is currently sold out.'); return; }
  if (!variantId) { window.location.href = '/collections/all'; return; }
  showToast('Adding to cart… ✦');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: quantity })
  })
  .then(r => { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
  .then(() => { setTimeout(() => { closeDrawer(); window.location.href = '/cart'; }, 800); })
  .catch(() => { showToast('Something went wrong. Please try again.'); });
}

// ── PRODUCT FILTER ──
function filterProducts(tag, btn) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.product-card[data-tags]').forEach(card => {
    if (tag === 'all' || card.dataset.tags.split(' ').includes(tag)) {
      card.removeAttribute('data-hidden');
      card.style.display = '';
    } else {
      card.dataset.hidden = 'true';
      card.style.display = 'none';
    }
  });
}

// ── TOAST ──
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3000);
}

// ── SEND DISCOUNT CODE VIA EMAILJS ──
function sendDiscountCode(email, onSuccess, onError) {
  emailjs.send('service_f7wbaha', 'template_7g4ddyc', { email: email })
    .then(() => { if (onSuccess) onSuccess(); })
    .catch(() => { if (onError) onError(); });
}

// ── EXIT INTENT POPUP ──
document.addEventListener('mouseleave', e => {
  if (e.clientY < 5 && !sessionStorage.getItem('bu_seen')) {
    const popup = document.getElementById('popup');
    if (popup) popup.classList.add('active');
  }
});

function closePopup() {
  const popup = document.getElementById('popup');
  if (popup) popup.classList.remove('active');
  sessionStorage.setItem('bu_seen', '1');
}

function submitPopup() {
  const input = document.getElementById('popupEmail');
  const v = input ? input.value.trim() : '';
  if (!v || !v.includes('@')) { showToast('Please enter a valid email address.'); return; }
  sessionStorage.setItem('bu_seen', '1');
  sendDiscountCode(v,
    () => {
      document.querySelector('.popup').innerHTML = `
        <div style="padding:2rem;text-align:center">
          <p style="font-family:'Playfair Display',serif;font-size:1.6rem;color:var(--light-gold);margin-bottom:0.8rem">Welcome! ✦</p>
          <p style="font-family:'Cormorant Garamond',serif;font-size:1rem;color:rgba(240,216,152,0.55);line-height:1.7">
            Your 10% discount code <strong style="color:var(--gold)">WELCOME10</strong> is on its way to your inbox. Use it at checkout!
          </p>
        </div>`;
      setTimeout(closePopup, 3500);
    },
    () => { showToast('Something went wrong. Please try again.'); }
  );
}

// ── FOOTER EMAIL SUBSCRIBE ──
function submitFooter() {
  const i = document.getElementById('footerEmail');
  const v = i ? i.value.trim() : '';
  if (!v || !v.includes('@')) { showToast('Please enter a valid email address.'); return; }
  sendDiscountCode(v,
    () => {
      showToast('Check your inbox for your discount code WELCOME10 ✦');
      i.value = '';
      i.placeholder = "✦ Check your inbox for WELCOME10";
    },
    () => { showToast('Something went wrong. Please try again.'); }
  );
}

// ── SCROLL REVEAL ──
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }
  });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// ── NAV SCROLL SHADOW ──
window.addEventListener('scroll', () => {
  const nav = document.getElementById('mainNav');
  if (nav) {
    if (window.scrollY > 60) nav.style.boxShadow = '0 2px 30px rgba(0,0,0,0.4)';
    else nav.style.boxShadow = 'none';
  }
});

// ── WHOLESALE ──
function openWholesale() { window.location.href = '/pages/wholesale'; }
function closeWholesale() {}
function submitWholesale() {}

// ── WHOLESALE PAGE FORM ──
function submitWholesalePage() {
  const name     = document.getElementById('wpName')     ? document.getElementById('wpName').value.trim()     : '';
  const business = document.getElementById('wpBusiness') ? document.getElementById('wpBusiness').value.trim() : '';
  const email    = document.getElementById('wpEmail')    ? document.getElementById('wpEmail').value.trim()    : '';
  const phone    = document.getElementById('wpPhone')    ? document.getElementById('wpPhone').value.trim()    : '';
  const type     = document.getElementById('wpType')     ? document.getElementById('wpType').value            : '';
  const volume   = document.getElementById('wpVolume')   ? document.getElementById('wpVolume').value          : '';
  const message  = document.getElementById('wpMessage')  ? document.getElementById('wpMessage').value.trim()  : '';
  const samples  = document.getElementById('wpSamples')  ? document.getElementById('wpSamples').checked       : false;
  if (!name || !email || !business) { showToast('Please fill in your name, email, and business name.'); return; }
  const btn = document.querySelector('.wholesale-submit-btn');
  if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }
  const fullMessage = `Business Type: ${type}\nMonthly Volume: ${volume}\nFree Samples Requested: ${samples ? 'Yes' : 'No'}\nPhone: ${phone || 'Not provided'}\n\nMessage:\n${message}`.trim();
  emailjs.send('service_f7wbaha', 'template_y8bc045', { name, email, business, city: '', message: fullMessage })
  .then(() => {
    const form    = document.getElementById('wholesalePageForm');
    const success = document.getElementById('wholesalePageSuccess');
    if (form)    form.style.display    = 'none';
    if (success) success.style.display = 'block';
  })
  .catch(() => {
    showToast('Something went wrong. Please email us at info@bunautopia.com');
    if (btn) { btn.textContent = "Send Inquiry — We'll Respond Within 24hrs"; btn.disabled = false; }
  });
}

// ── CONTACT MODAL ──
function openContact() {
  document.getElementById('contactOverlay').classList.add('open');
  document.getElementById('contactModal').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeContact() {
  document.getElementById('contactOverlay').classList.remove('open');
  document.getElementById('contactModal').classList.remove('open');
  document.body.style.overflow = '';
}
function submitContact() {
  const name    = document.getElementById('cName').value.trim();
  const email   = document.getElementById('cEmail').value.trim();
  const subject = document.getElementById('cSubject').value.trim();
  const message = document.getElementById('cMessage').value.trim();
  if (!name || !email || !message) { showToast('Please fill in your name, email, and message.'); return; }
  const btn = document.querySelector('#contactForm .wholesale-btn');
  btn.textContent = 'Sending…';
  btn.disabled = true;
  emailjs.send('service_6yp6jd8', 'template_n18mk5m', { name, email, subject, message }, 'aeViFFX55fII18XnX')
  .then(() => {
    document.getElementById('contactForm').style.display    = 'none';
    document.getElementById('contactSuccess').style.display = 'block';
  })
  .catch(() => {
    showToast('Something went wrong. Please email us directly at info@bunautopia.com');
    btn.textContent = 'Send Message ✦';
    btn.disabled = false;
  });
}